import type { AnyObject, AnyObjectSchema, Maybe, ObjectSchema } from "yup";

/**
 * Casts a concrete Yup object schema to {@link AnyObjectSchema}.
 *
 * tsgo no longer treats Yup's `Shape<any>` mapped type as structurally covering all keys,
 * so `ObjectSchema<T>` is not assignable to `ObjectSchema<any>` / `AnyObjectSchema`.
 * @see https://github.com/microsoft/typescript-go/issues/4451
 */
export const toAnyObjectSchema = <T extends Maybe<AnyObject>>(schema: ObjectSchema<T>): AnyObjectSchema =>
  schema as AnyObjectSchema;
